import * as React from 'react'
import { type VariantProps } from 'class-variance-authority'

import { cn } from '@/utils'
import { inputVariants } from './input-variants'

export interface InputProps extends Omit<React.ComponentProps<'input'>, 'size'> {
  error?: boolean
  size?: VariantProps<typeof inputVariants>['size']
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, size, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        aria-invalid={error ? true : undefined}
        className={cn(inputVariants({ size }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export { Input }
